export function lower(str: string) {
	return str ? str.toLowerCase() : '';
}
